import { Constants } from '@pwc/pwc-deals-web-common';
import DROPPABLE_LOCATION_IDS from './droppableLocationIds';
import { generateDroppableLocationIdWithSection } from './generateDroppableLocationIdWithSection';
import { layoutTypeToDroppableLocationIdMap } from './generateDroppableLocationSetForSection';

export const generateTargetDroppableLocationIdsNew = (section) => {
  const droppableLocationIds =
    layoutTypeToDroppableLocationIdMap[section.layoutType];
  const targetDroppableLocationIds = [];
  droppableLocationIds.forEach((dropLocId) => {
    const dropLocIdWithOrder = generateDroppableLocationIdWithSection(
      dropLocId,
      section.order
    );
    targetDroppableLocationIds.push(dropLocIdWithOrder);
  });
  return targetDroppableLocationIds;
};

export const generateTargetDroppableLocationIds = (section) =>
  section.layoutType === Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN
    ? [
        generateDroppableLocationIdWithSection(
          DROPPABLE_LOCATION_IDS.DOUBLE_COLUMN_FIRST_AREA_ID,
          section.order || 1
        ),
        generateDroppableLocationIdWithSection(
          DROPPABLE_LOCATION_IDS.DOUBLE_COLUMN_SECOND_AREA_ID,
          section.order || 1
        ),
      ]
    : [
        generateDroppableLocationIdWithSection(
          DROPPABLE_LOCATION_IDS.SINGLE_COLUMN_AREA_ID,
          section.order || 1
        ),
      ];
